function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "kvp-avoid_svg__a",
  x1: "0%",
  x2: "100%",
  y1: "55.339%",
  y2: "55.339%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#00907F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#48D59F"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#E6E6E6",
  strokeLinejoin: "round",
  strokeWidth: 8,
  d: "M49.81 2.458l50.67 50.67H74.81v53h-50v-53H-.859l50.67-50.67z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M53 64h38v52H53z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#kvp-avoid_svg__a)",
  fillRule: "nonzero",
  d: "M68.364 108.985v-4.95c6.5-1 11.45-5.05 11.45-11.4 0-7.3-5.9-8.95-11.45-9.95v-8.25c2.6.75 4.8 2.35 6.4 4.6l4.8-5.45c-2.15-3.05-6.25-5.15-11.2-5.75v-4.85h-5.35v4.85c-6.5.85-11.4 4.8-11.4 11 0 7.05 5.85 8.7 11.4 9.75v8.85c-3.3-.6-6.1-2.35-8.3-5.35l-4.85 5.6c2.6 3.6 7.65 5.95 13.15 6.45v4.85h5.35zm-5.35-27.35c-2.35-.65-4-1.55-4-3.5 0-2.15 1.6-3.45 4-3.9v7.4zm5.35 15.85v-7.85c2.5.65 4.3 1.6 4.3 3.65 0 2.45-1.7 3.7-4.3 4.2z",
  transform: "translate(8.798 8.115)"
}));

function SvgKvpAvoid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99 118"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5OSAxMTgiPjxkZWZzPjxsaW5lYXJHcmFkaWVudCBpZD0iYSIgeDE9IjAlIiB4Mj0iMTAwJSIgeTE9IjU1LjMzOSUiIHkyPSI1NS4zMzklIj48c3RvcCBvZmZzZXQ9IjAlIiBzdG9wLWNvbG9yPSIjMDA5MDdGIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdG9wLWNvbG9yPSIjNDhENTlGIi8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBzdHJva2U9IiNFNkU2RTYiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iOCIgZD0iTTQ5LjgxIDIuNDU4bDUwLjY3IDUwLjY3SDc0LjgxdjUzaC01MHYtNTNILS44NTlsNTAuNjctNTAuNjd6Ii8+PHBhdGggZmlsbD0iI0ZGRiIgZD0iTTUzIDY0aDM4djUySDUzeiIvPjxwYXRoIGZpbGw9InVybCgjYSkiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTY4LjM2NCAxMDguOTg1di00Ljk1YzYuNS0xIDExLjQ1LTUuMDUgMTEuNDUtMTEuNCAwLTcuMy01LjktOC45NS0xMS40NS05Ljk1di04LjI1YzIuNi43NSA0LjggMi4zNSA2LjQgNC42bDQuOC01LjQ1Yy0yLjE1LTMuMDUtNi4yNS01LjE1LTExLjItNS43NXYtNC44NWgtNS4zNXY0Ljg1Yy02LjUuODUtMTEuNCA0LjgtMTEuNCAxMSAwIDcuMDUgNS44NSA4LjcgMTEuNCA5Ljc1djguODVjLTMuMy0uNi02LjEtMi4zNS04LjMtNS4zNWwtNC44NSA1LjZjMi42IDMuNiA3LjY1IDUuOTUgMTMuMTUgNi40NXY0Ljg1aDUuMzV6bS01LjM1LTI3LjM1Yy0yLjM1LS42NS00LTEuNTUtNC0zLjUgMC0yLjE1IDEuNi0zLjQ1IDQtMy45djcuNHptNS4zNSAxNS44NXYtNy44NWMyLjUuNjUgNC4zIDEuNiA0LjMgMy42NSAwIDIuNDUtMS43IDMuNy00LjMgNC4yeiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOC43OTggOC4xMTUpIi8+PC9nPjwvc3ZnPgo=";
export { SvgKvpAvoid as ReactComponent };